/** This is to make variables of action names to prevent errors
 *  during naming/using action creators and reducer */

export const FETCH_POSTS = "FETCH_POSTS";

// Auth Reducer
export const LOGOUT = "LOGOUT";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAIL = "AUTH_FAIL";
export const AUTH_START = "AUTH_START";
